(ns teamoesterreich.lebensretter-mode.other-documents
  (:require [clojure.string]
            [clojure.string :as str]
            [goog.date.DateTime]
            [reagent-material-ui.components :as mui]
            [reagent-material-ui.icons.cloud-upload :refer [cloud-upload]]
            [reagent-material-ui.icons.delete-outline :refer [delete-outline]]
            [reagent-material-ui.icons.insert-drive-file :refer [insert-drive-file]]
            [reagent-material-ui.icons.picture-as-pdf :refer [picture-as-pdf]]
            [reagent-material-ui.icons.warning :refer [warning]]
            [reagent.core :as r]
            [teamoesterreich.firebase.storage-provider :as storage-provider]
            [teamoesterreich.store :as store]
            [teamoesterreich.user-mode.actions :as a]
            [teamoesterreich.user-mode.ui-helper.are-you-sure-modal :as ays-modal]
            [teamoesterreich.user-mode.ui-helper.preview-modal :as preview-modal]
            [teamoesterreich.util.helper :as h]
            [teamoesterreich.util.log :as log]))

(def TYPES
  {"identification"             "Ausweis"
   "picture"                    "Profilbild"
   "lebensretter-qualification" "Lebensretter Qualifikation"
   "other"                      "Sonstiges"
   })

(defn select-type [!state]
  (fn []
    [mui/select
     {:fullWidth true
      :value     (:type @!state)
      :onChange  (fn [e]
                   (log/out "Change type  -> " (h/event-value e))
                   (swap! !state assoc-in [:type] (h/event-value e)))
      }
     [mui/menu-item {:key "identification" :value "identification"} "Ausweis"]
     [mui/menu-item {:key "picture" :value "picture"} "Profilbild"]
     [mui/menu-item {:key "lebensretter-qualification" :value "lebensretter-qualification"} "Lebensretter Qualifikation"]
     [mui/menu-item {:key "other" :value "other"} "Sonstiges"]
     ]))

(defn upload-part [!state !userId]
  (fn []
    (log/out "upload-part  -> " @!state @!userId)
    [:div
     [:input {:accept "image/" :id "photoUpload" :type "file"
              :style  {:display "none"}}]
     [:label {:for "photoUpload"}



      [mui/button {
                   :variant   "outlined"
                   :startIcon (r/as-element [cloud-upload])
                   :component "label"
                   :style     {:width "240px"}
                   }
       "hochladen" (when (:progress @!state) (str " ... " (:progress @!state) "%"))
       [:input {:accept   "image/" :id "photoUpload"
                :type     "file"
                :hidden   true
                :onChange (fn [e]
                            (let [file (.item e.target.files 0)]
                              ;(log/out "################################################  upload fired..." @!userId " <" (:type @!state) "> file" file)
                              (storage-provider/upload-user-file file @!userId
                                                                 (fn [path]
                                                                   (log/out "<<<<<<<<<<<<  upload callback fired " path)
                                                                   (a/add-user-document {:deleted false :locked false :path path :name (.-name file) :uploaded (js/Date.) :type (:type @!state)})
                                                                   (swap! !state assoc :progress nil))
                                                                 (fn [p] (swap! !state assoc :progress p)))
                              ))
                }]]

      ]
     ]
    )

  )



(defn document-block [documentId {:keys [type name path uploaded locked valid-from valid-until rejected rejectMessage] :as doc}]
  (let [!state (r/atom {:url nil :loading false :show-delete-modal false :enlarge false})
        !enlarge (r/cursor !state [:enlarge])
        !show-delete-modal (r/cursor !state [:show-delete-modal])
        delete-fn #(reset! !show-delete-modal true)
        drop-file-fn #(a/set-user-document documentId {:deleted true})
        ]
    (fn []
      (when (and path (not (:loading @!state)))
        ;(storage-provider/get-metadata path (fn [metadata]
        ;                                      (log/out "store callback metadata " metadata)
        ;                                      (swap! !state assoc :metadata metadata)
        ;                                      ))
        (storage-provider/get-download-url-and-type path
                                                    (fn [{:keys [url content-type]}]
                                                      (log/out "store callback previewUri " path url content-type)
                                                      (swap! !state assoc :url url :path path)
                                                      (swap! !state assoc :content-type content-type)
                                                      (swap! !state assoc :loading true)))
        )
      (log/out "document-block load")
      [mui/grid
       {
        :key   (str "document-block-" documentId)
        :xs    12
        :lg    6
        :xl    4
        :style {:padding "15px 15px 0 15px"}
        }
       [preview-modal/modal (:url @!state) !enlarge]
       [ays-modal/are-you-sure-modal !show-delete-modal "Willst du wirklich dieses Dokument löschen?" "Löschen" drop-file-fn]
       [mui/card
        {:variant "outlined"}
        [mui/card-content {}
         (when path
           (if (and (:content-type @!state) (:url @!state))
             (cond
               (str/starts-with? (str (get-in @!state [:content-type])) "image/")
               [:img {:src     (:url @!state)
                      :onClick #(swap! !state assoc :enlarge (not (:enlarge @!state)))
                      :style   {:position "relative" :float "right" :maxHeight "120px" :maxWidth "100px"} :alt "Ansicht"}]

               (= (get-in @!state [:content-type]) "application/pdf")
               [:div {:style {:position "relative" :float "right"}}
                [:a {:href (:url @!state) :target "_blank"} [picture-as-pdf {:fontSize "large"}]]]

               :else
               [:div {:style {:position "relative" :float "right"}}
                [insert-drive-file {:fontSize "large"}]])
             [mui/circular-progress {:style {:float "right" :maxHeight "50px"}}]
             ))
         [:div {:style {:width "calc(100% - 122px)" :overflow "hidden"}}
          [mui/typography {:variant "span" :gutterBottom true :size "small"} (or (get TYPES type) (str "?" type))]
          [mui/typography {:variant "span"} (or name path)]
          [:br]
          [mui/typography {:variant "span" :gutterBottom true :size "small"}
           (when uploaded (str (.toLocaleDateString (js/Date. (* 1000 ^js (.-seconds uploaded))) "de-AT") " " (.toLocaleTimeString (js/Date. (* 1000 ^js (.-seconds uploaded))) "de-AT")))]
          [:br]
          [mui/typography {:variant "span" :gutterBottom true :size "small"}
           (cond
             rejected [:div {:style {:color "darkred"}} [warning {:size "small"}] (str " Abgelehnt: " rejectMessage)]
             valid-until (str "gültig bis" (.toLocaleDateString (js/Date. (* 1000 ^js (.-seconds valid-until))) "de-AT"))
             :else ""                                       ;(str "--" doc)
             )
           ]
          ]

         ]
        [mui/card-actions
         (when-not locked
           [mui/button {:size    "small" :color "secondary"
                        :endIcon (r/as-element [delete-outline])
                        :onClick delete-fn
                        } "Löschen"])
         ]

        ]]
      )))


(defn other-documents []
  (let [!userId (r/cursor store/app-state [:firebase-uid])
        !user-documents (r/cursor store/app-state [:user-documents])
        !state (r/atom {:process false :type "identification"})]
    [mui/grid
     {:container  true
      :direction  "rows"
      :justify    "center"
      :alignItems "center"
      :spacing    4}

     [mui/grid
      {:xs 12 :style {:padding "10px"}}
      [:h2 "Deine Dokumente"]
      [:span "Hier kannst du weitere Dokumente hochladen"]
      [:br]]

     [mui/grid
      {:xs 6 :style {:padding "0 5px 0 10px"}}
      [(select-type !state)]]

     [mui/grid
      {:xs 6}
      [(upload-part !state !userId)]]

     (for [[documentId user-document] @!user-documents]
       (when-not (true? (:deleted user-document))
         ^{:key (str "document-" documentId)} [document-block documentId user-document]
         ))
     ]))